(function () {
  'use strict';

  // Show sticky mobile CTA once hero scrolls out of view
  var sticky = document.querySelector('.obr-sticky');
  if (!sticky) return;

  var hero = document.querySelector('.obr-hero');
  if (!hero) {
    // No hero — show sticky after 2.5 s
    setTimeout(function () { sticky.classList.add('obr-sticky--visible'); }, 2500);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        sticky.classList.add('obr-sticky--visible');
      } else {
        sticky.classList.remove('obr-sticky--visible');
      }
    });
  }, { threshold: 0.1 });

  io.observe(hero);
})();
